export class CredentialsProbeAssumeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ok",
            "baseName": "ok",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleSessionName",
            "baseName": "roleSessionName",
            "type": "string",
            "format": ""
        },
        {
            "name": "latencyMs",
            "baseName": "latencyMs",
            "type": "number",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "ProbeError",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CredentialsProbeAssumeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
